/* src/app/shared/dialogs/ag-conditional-dialog/ag-conditional-dialog.component.scss */
.conditional-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  background: #ffffff;
}
.conditional-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px;
  flex-shrink: 0;
}
.conditional-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.conditional-header-copy h2,
.conditional-header-copy p {
  margin: 0;
}
.conditional-header-copy h2 {
  color: #18181b;
}
.conditional-header-copy p {
  color: #71717a;
}
.conditional-rule-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #dbeafe;
  color: #18181b;
  flex-shrink: 0;
}
.conditional-body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  overflow-y: auto;
  flex: 1 1 auto;
}
.conditional-loader {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}
.condition-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.condition-group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background: #f4f4f5;
  cursor: pointer;
  text-align: left;
}
.condition-group-title {
  flex: 1 1 auto;
  color: #71717a;
  letter-spacing: 0.04em;
}
.condition-group-summary {
  color: #71717a;
  white-space: nowrap;
}
.condition-group-chevron {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}
.condition-group-chevron-expanded {
  transform: rotate(180deg);
}
.condition-group-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.condition-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.condition-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.condition-copy h5,
.condition-copy p {
  margin: 0;
}
.condition-copy h5 {
  color: #18181b;
}
.condition-copy p {
  color: #71717a;
}
.condition-row {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
.condition-row-center {
  align-items: center;
}
.status-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
.condition-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.week-time-stack {
  gap: 0;
}
.weekday-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
}
.time-config-column {
  padding: 20px;
  border-bottom: 1px solid #e4e4e7;
}
.condition-field {
  flex: 1 1 0;
  min-width: 0;
}
flow-select.condition-field ::ng-deep .flow-select {
  width: 100% !important;
}
.condition-divider {
  width: 100%;
  height: 1px;
  margin: 0;
  border: 0;
  background: #e4e4e7;
}
.condition-clear {
  display: flex;
  justify-content: flex-start;
  padding: 16px 20px;
}
.conditional-exceptions {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 24px;
  border-top: 1px solid #e4e4e7;
}
.conditional-exceptions-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.conditional-exceptions-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.conditional-exceptions-copy h3,
.conditional-exceptions-copy p {
  margin: 0;
}
.conditional-exceptions-copy h3 {
  color: #18181b;
}
.conditional-exceptions-copy p {
  color: #71717a;
}
.conditional-rule-bar-exception {
  border-radius: 8px;
  padding: 16px 20px;
}
.conditional-exceptions-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.conditional-footer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid #e4e4e7;
  background: #ffffff;
  flex-shrink: 0;
}
.conditional-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.conditional-summary {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #eff6ff;
}
.conditional-warning {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.conditional-warning-text {
  margin: 0;
  color: #991b1b;
}
.conditional-summary-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.conditional-summary-text {
  margin: 0;
  color: #1d4ed8;
}
.conditional-summary-text strong {
  font-weight: 600;
}
.weekday-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.time-of-day-band {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 20px;
  background: #fafafa;
}
.time-of-day-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
}
.time-of-day-label {
  min-width: 92px;
  margin: 0;
  color: #18181b;
}
.time-of-day-fields {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}
.time-span-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #f4f4f5;
}
.time-span-input input {
  width: 60px;
  border: none;
  outline: none;
  background: transparent;
  color: #18181b;
}
.time-span-input img {
  width: 16px;
  height: 16px;
}
.date-time-condition {
  display: flex;
  flex-direction: column;
}
.date-time-description {
  margin: 0;
  padding: 16px 20px;
  color: #71717a;
}
.date-time-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid #e4e4e7;
}
.date-time-label {
  color: #18181b;
}
.date-time-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.date-time-field {
  flex: 1 1 0;
  min-width: 0;
  height: 48px;
}
.date-time-field.time-span-input {
  justify-content: space-between;
  border-color: transparent;
  background: #f4f4f5;
}
.date-time-field.time-span-input input {
  width: 100%;
  background: transparent;
}
.date-time-field.time-span-input input::placeholder {
  color: #71717a;
}
.check-box-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.offset-legend {
  display: flex;
  justify-content: space-between;
  color: #71717a;
}
.offset-value-row {
  display: flex;
  justify-content: center;
  width: 100%;
}
.slidecontainer {
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 12px;
  background: #f4f4f5;
}
.slider {
  -webkit-appearance: none;
  appearance: none;
  width: 75%;
  height: 16px;
  background-color: transparent;
  background-image: url(https://aeroguestblobstorageprod.blob.core.windows.net/images23-24/communication/dots_slider.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 1px;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  border-radius: 12px;
}
.slider:hover {
  opacity: 1;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 13px;
  height: 36px;
  background: url(https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/black_rectangle.svg);
  cursor: pointer;
}
.slider::-moz-range-thumb {
  width: 13px;
  height: 36px;
  background: url(https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/black_rectangle.svg);
  cursor: pointer;
}
.slider-value {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  height: 48px;
  padding: 4px 12px;
  border-radius: 12px;
  background: #18181b;
  color: #ffffff;
}
.slider-value-label {
  height: 16px;
  font-size: 12px;
  line-height: 16px;
}
.slider-value-input {
  display: flex;
  align-items: center;
  line-height: 16px;
}
.slider-value-unit {
  font-size: 12px;
  color: #ffffff;
}
.offset-input {
  width: 27px;
  height: 20px;
  margin-right: 4px;
  border: 1px solid #71717a;
  border-radius: 4px;
  background: transparent;
  color: #ffffff;
  text-align: right;
}
.offset-input:focus {
  outline: 1px solid #71717a;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.radio-button-container {
  display: flex;
  align-items: center;
  gap: 12px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.black-radio {
  width: 18px;
  height: 18px;
  border: 1px solid #71717a;
  outline: none;
  accent-color: #18181b;
  cursor: pointer;
}
.fg-subtle {
  color: #71717a;
}
.day-of-week-description {
  padding: 16px 20px;
  border-bottom: 1px solid #e4e4e7;
}
.guidance-desc {
  padding: 8px 16px;
  border-bottom: 1px solid #e4e4e7;
}
.range-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
}
.range-field {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.range-label {
  color: #18181b;
}
.range-separator {
  color: #18181b;
  padding-top: 46px;
  white-space: nowrap;
}
.legacy-rule-warning {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 20px 16px;
  padding: 12px;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  background: #fff7ed;
}
.legacy-rule-warning img {
  flex-shrink: 0;
  margin-top: 2px;
}
.legacy-rule-warning .legacy-rule-warning-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.legacy-rule-warning h5 {
  margin: 0;
  color: #c2410c;
}
.legacy-rule-warning p {
  margin: 0;
  color: #9a3412;
}
.match-type-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e4e7;
}
.match-type-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.match-type-copy h5,
.match-type-copy p {
  margin: 0;
}
.match-type-copy h5 {
  color: #18181b;
}
.match-type-copy p {
  color: #71717a;
}
.phrase-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.phrase-label {
  color: #18181b;
}
.phrase-input-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
}
.phrase-input {
  flex: 1 1 0;
  min-width: 0;
}
/*# sourceMappingURL=ag-conditional-dialog.component.css.map */
